import React from "react";

const SkitPage = () => {
  return (
    <div
      style={{
        maxWidth: 600,
        margin: "40px auto",
        padding: "2rem",
        background: "#181818",
        borderRadius: 16,
        color: "#f3f3f3",
        fontFamily: "serif",
        boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
      }}
    >
      <div style={{ fontSize: "1.1rem", lineHeight: 1.7 }}>
        <div
          style={{ fontStyle: "italic", color: "#bdbdbd", marginBottom: 18 }}
        >
          From <b>Dimension 20: The Unsleeping City</b> <br />
          (Brennan Lee Mulligan as Robert Moses)
        </div>
        <div style={{ marginBottom: 18, color: "#a0a0a0" }}>
          <b>INT. CITY PLANNING OFFICE – NIGHT</b>
        </div>
        <div style={{ marginBottom: 18 }}>
          <span style={{ fontWeight: 600, letterSpacing: 1, color: "#e0e0e0" }}>
            ROBERT MOSES
          </span>{" "}
          stands before an illuminated map of the city’s roads.
        </div>
        <div style={{ marginLeft: 32, marginBottom: 12 }}>
          <span style={{ fontWeight: 600, color: "#e0e0e0" }}>
            ROBERT MOSES
          </span>
          <div
            style={{ marginTop: 8, marginBottom: 8, whiteSpace: "pre-line" }}
          >
            You think people make choices? No —{"\n"}
            people think they make choices.{"\n"}
            They think they’re gonna steer right,{"\n"}
            or steer left—
            <div style={{ margin: "10px 0" }}>(beat)</div>
            But they didn’t build the roads.{"\n"}
            The big choices already got made{"\n"}
            for them, a long time ago.
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkitPage;
